import React, { useState } from "react";

const TextArea = ({
  label,
  value,
  onChange,
  maxLength = 200,
  placeholder = "",
  className = "",
  required = false,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);

  const handleBlur = () => {
    setIsFocused(false);
    setHasInteracted(true);
  };

  const showError = hasInteracted && required && !value;

  return (
    <div className={`relative ${className}`}>
      <textarea
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={handleBlur}
        maxLength={maxLength}
        placeholder={placeholder}
        className={`w-full p-3 border ${
          showError
            ? "border-red-500 focus:border-red-500"
            : isFocused
            ? "border-gray-600"
            : "border-gray-400"
        } rounded-lg outline-none bg-white transition-colors min-h-[100px] resize-none`}
      />
      <label
        className={`absolute -top-2 left-2 px-1 text-sm ${
          showError ? "text-red-500" : "text-gray-500"
        } bg-white transition-colors`}
      >
        {label}
        {!required && <span className="text-gray-400 ml-1 text-xs">(optional)</span>}
      </label>
      <div className="absolute bottom-2 right-2 text-xs text-gray-400">
        {value.length}/{maxLength}
      </div>
    </div>
  );
};

export default TextArea; 